import { EasyError } from "../entities/EasyError";
import { ApiError, ApiResult } from "../types/graphql";
import { showEasyNotification } from "@/src/easy-ui/main";
import type { EasyErrorFragment } from "@/src/shared/graphql/fragments/error.generated";
import type { GraphQLFormattedError } from "graphql/index";

// eslint-disable-next-line complexity
export const handleErrors = (result?: ApiResult, gqlErrors?: ReadonlyArray<GraphQLFormattedError>) => {
  if (result?.success === false || result?.errors?.length || gqlErrors?.length) {
    logErrors(result?.errors);
    logErrors(gqlErrors);
    throw new EasyError(result?.errors ?? [], gqlErrors ?? []);
  }
};

const logErrors = (errors?: ReadonlyArray<ApiError | GraphQLFormattedError> | null) => {
  if (import.meta.env.VITE_APP_ENABLE_CONSOLE_LOGGING) {
    for (const error of errors ?? []) {
      // eslint-disable-next-line no-console
      console.error(error);
    }
  }
};

// for rest API endpoint errors
export const notifyAPIError = (err: unknown, fallbackMsgLocaleKey = "error_something_went_wrong") => {
  if (!(err instanceof Error)) return;

  const message = err.message || window.EasyLocale.getLocale(fallbackMsgLocaleKey);
  showEasyNotification({ message });
};

export const notifyOnGraphqlValidationErrors = (response?: { errors?: EasyErrorFragment[] | null } | null) => {
  if (!response?.errors?.length) return;
  response.errors!.forEach((err: EasyErrorFragment) => notifyAPIError(new Error(err.messages![0])));
};
